import { useState } from "react";
import stylez from "./NewContacts.module.css";
import { useNavigate } from "react-router-dom";
import SuccessDialogue from "../../../Components/Shared/SuccessDialog/SuccessDialog";
import axiosInstance from "../../../Configuration/axiosInstance";
import LoadingSpinner from "../../../Components/Shared/Loader/Loader";

const NewContacts = () => {
  const [contact, setContact] = useState({
    businessName: "",
    abn: "",
    address: "",
    pic: "",
    phone: "",
    email: "",
    customer_type: "",
    comments: "",
  });
  const [msg, setMsg] = useState("");
  const [dialogBox, setDialogBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    event.preventDefault();
    // Prevent the default behaviour
    setContact({ ...contact, [name]: value });
  };

  const resetForm = () => {
    setContact({
      businessName: "",
      abn: "",
      address: "",
      pic: "",
      phone: "",
      email: "",
      customer_type: "",
      comments: "",
    });
  };

  const handleButton = () => {
    setLoading(true);
    // Check if all required fields are initialized
    if (!contact.businessName) {
      setLoading(false);
      setMsg("Please fill in all required fields ❗");
      setDialogBox(true);
      setTimeout(() => {
        setDialogBox(false);
      }, 2000);
      return;
    }

    // Send the data to the backend
    axiosInstance
      .post(`customers`, contact)
      .then((response) => {
        setLoading(false);
        setMsg(response.data.message);
        setDialogBox(true);
      })
      .catch((error) => {
        // Handle error if the API call fails
        setLoading(false);
        alert(error?.data?.message);
      });
  };
  const handleClose = () => {
    setDialogBox(false);
    setMsg("");
  };

  return (
    <>
      <h2>Add New Customer</h2>
      <div className={stylez.box}>
        <SuccessDialogue show={dialogBox} handleClose={handleClose} msg={msg} />
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className={stylez.newContainer}>
              <div className={stylez.divs}>
                <label>Business Name: </label>
                <input
                  value={contact.businessName}
                  type="text"
                  name="businessName"
                  placeholder="ABC Restaurant Pty Ltd"
                  onChange={handleChange}
                />
                <label>Address: </label>
                <input
                  value={contact.address}
                  type="text"
                  name="address"
                  placeholder="25 Smith St,Blacktown 2148 NSW"
                  onChange={handleChange}
                />
                <label>Customer Type:</label>
                <select
                  name="customer_type"
                  value={contact.customer_type}
                  onChange={handleChange}
                >
                  <option>Select an option</option>
                  <option value="End User">End User</option>
                  <option value="Reseller">Reseller</option>
                  <option value="End User & Reseller">
                    End User & Reseller
                  </option>
                </select>
                <hr />
              </div>
              <div className={stylez.divs}>
                <label>Phone:</label>
                <input
                  value={contact.phone}
                  type="text"
                  name="phone"
                  maxLength={10}
                  placeholder="0452402321"
                  onChange={handleChange}
                />
                <label>ABN :</label>
                <input
                  value={contact.abn}
                  type="text"
                  name="abn"
                  placeholder="78235523677"
                  maxLength={11}
                  onChange={handleChange}
                />
                <label>Comments:</label>
                <input
                  value={contact.comments}
                  type="text"
                  name="comments"
                  placeholder="Delivery via n lane"
                  onChange={handleChange}
                />
              </div>
              <div className={stylez.divs}>
                <label>Person In Charge</label>
                <input
                  value={contact.pic}
                  type="text"
                  name="pic"
                  placeholder="John Smith"
                  onChange={handleChange}
                />

                <label>Email:</label>
                <input
                  value={contact.email}
                  type="email"
                  name="email"
                  placeholder="accounts@abc.com.au"
                  onChange={handleChange}
                ></input>
              </div>
            </div>
            <button className="confirmBtn" onClick={handleButton}>
              Add
            </button>
          </>
        )}
      </div>
    </>
  );
};
export default NewContacts;
